import PubSub from "underpub-js";

var ButtonArrow = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-ButtonArrow',
	};

	$.extend(true, this.options, options);

};

ButtonArrow.prototype.init = function() {

	var self = this;

};

export default ButtonArrow;
